import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const AttendanceReportQuery = graphql.persisted(
  "AttendanceReportQuery",
  graphql(`
    query AttendanceReportQuery(
      $classOfferingId: ID!
      $fromDate: ISO8601Date!
      $toDate: ISO8601Date!
    ) {
      classOffering(id: $classOfferingId) {
        id
        attendanceReport(fromDate: $fromDate, toDate: $toDate) {
          fromDate
          toDate
          recordedDayCount
          students {
            person { id firstName lastName }
            presentCount
            absentCount
            tardyCount
            excusedCount
            recordedCount
            attendanceRate
          }
          days {
            date
            presentCount
            absentCount
            tardyCount
            excusedCount
            recordedCount
          }
        }
      }
    }
  `)
);

export { AttendanceReportQuery };

export function useAttendanceReportQuery(classOfferingId?: string, fromDate?: string, toDate?: string) {
  return useQuery(AttendanceReportQuery, {
    variables: {
      classOfferingId: classOfferingId!,
      fromDate: fromDate!,
      toDate: toDate!,
    },
    skip: !classOfferingId || !fromDate || !toDate || fromDate > toDate,
  });
}
